import { v4 } from 'uuid';

export function getUuid() {
  return v4();
}
